import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PilatesHero } from './components/PilatesHero';
import { PilatesSocialProof } from './components/PilatesSocialProof';
import { PilatesProblem } from './components/PilatesProblem';
import { PilatesContents } from './components/PilatesContents';
import { Testimonials } from './components/Testimonials';
import { PilatesGuarantee } from './components/PilatesGuarantee';
import { PilatesFAQ } from './components/PilatesFAQ';
import { PilatesCost } from './components/PilatesCost';
import { PilatesPricing } from './components/PilatesPricing';
import { PilatesFooter } from './components/PilatesFooter';
import { PilatesStickyCTA } from './components/PilatesStickyCTA';
export function App() {
  return <div className="min-h-screen bg-padel-dark font-sans text-gray-100 selection:bg-padel-lime selection:text-padel-dark" data-id="element-0" data-mp="2whxabqim5ie4">
    <MetaPixel data-id="element-1" data-mp="23vcmh01cjofb" />
    <PilatesHero data-id="element-2" data-mp="23vupcfiil0w7" />
    <PilatesSocialProof data-id="element-3" data-mp="23u9vyt7xrnzx" />
    <PilatesProblem data-id="element-4" data-mp="23v2sz2h3ez4v" />
    <PilatesContents data-id="element-5" data-mp="23ti67z10skhk" />
    <PilatesPricing data-id="element-6" data-mp="3ikh8ubu2yx01" />
    <Testimonials data-id="element-7" data-mp="3iiwf2oflbi38" />
    <PilatesGuarantee data-id="element-8" data-mp="3ijfvg0pldyf5" />
    <PilatesFAQ data-id="element-9" data-mp="3ii4t85bsoyq5" />
    <PilatesCost data-id="element-10" data-mp="3mlj6io8cn0zw" />
    <PilatesFooter data-id="element-11" data-mp="3ml17jjuay8oa" />
    <PilatesStickyCTA data-id="element-12" data-mp="3mk8710lxsfel" />
  </div>;
}